import { signOut } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      // Limpiar sessionStorage para compatibilidad con código existente
      sessionStorage.clear();
      
      // Cerrar sesión en Firebase Auth
      await signOut(auth);
      
      // El AuthContext detectará automáticamente el cambio y user será null
      // Navegar inmediatamente ya que el AuthContext manejará la limpieza
      navigate('/', { 
        replace: true, 
        state: { fromLogout: true } 
      });
      
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      Swal.fire({
        title: 'Error',
        text: 'Error al cerrar sesión. Intenta nuevamente.',
        icon: 'error',
        confirmButtonText: 'Cerrar',
        confirmButtonColor: 'var(--color-1)',
      });
    }
  };

  return logout;
};
